module.exports = __webpack_public_path__ + "img/superuDist.d27817e0.jpg";